// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.carrier.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    version: '1.000.0',
    production: false,
    errMsg: 'Failed to complete. Please try again.',
    partner: true,
    config: {
        "stage": "prod",
        "appName": "CPM",
        "multiRegion": false,
        "defaultRegion": "1",
        "regionsList": ["1"],
        "auth": {
            "caretakerUrl": "https://caretaker.webctrl.ai/api/v1",
            "gatekeeperUrl": "https://gatekeeper.webctrl.ai/api/v1",
        },
        "1" : {
            "regionName": "North America",
            "haystackUrl": "https://silo.service.webctrl.ai/",
            "tagsUrl": "https://silo.service.webctrl.ai/v2/sitePointTags",
            "cpmUrl": "https://chiller-plant.service.webctrl.ai/",
            "alertsUrl": "https://alerts.service.webctrl.ai/",
            "pasUrl": `https://portfolio-analytics.service.webctrl.ai/`,
        }
    }
};